export const scrollIntoViewWrapper = (element, blockType = 'center') => {
    const target = document.getElementById(element);
    target &&
        target?.scrollIntoView(<any>{
            behavior: 'smooth',
            block: blockType,
            inline: 'center',
        });
};
